
import { AreaResource, AreaType } from '../../area.resource';

export class AreaEnermanResource extends AreaResource {
   public static readonly TYPE =  AreaType.enerman;

   profile_enabled: AssignmentResource;
   cdc_associated = [];
   notes: string;

   constructor() {
    super(AreaEnermanResource.TYPE);
   }
}

export class AssignmentResource{ 
  profile: ProfileResource;
  enabled_disabled: boolean;
  enable_disabled: boolean;
} 

export class ProfileResource{ 
   id: number;
   description: string;
} 


export class CdcResource { 
   value: string;
   enable_disabled: boolean;
}
